<template>
  <div>
    <v-dialog v-model="confirmDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('crudFamiliasAtendimento.messages.systemMessage') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ this.mensagemdialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
            this.messageDismissButton }}</v-btn>
          <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{
            this.messageConfirmButton }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <merus-data-table :headers="headers" :items="familiasAtendimento" :search="search" :loading="loadingtable"
      :loading-text="$t('crudFamiliasAtendimento.loading')" dense class="elevation-7"
      locale="pt" style="border-radius: 10px" :default-multi-sort="defaultSort"

 cod-tabela="FAMILIASATENDIMENTO" @update:headers="headers = $event">
      <template v-slot:toolbar>
        <cadastro-toolbar :title="$t('crudAtendimentoConfig.tabs.familias')" :token="token" :items="familiasAtendimento"
          csv-title="familias_atendimento" @search="search = $event">
          <template v-slot:add>
            <v-dialog v-model="dialog" max-width="100%">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar dark color="primary" ref="myToolbar">
                  <v-btn icon dark @click="close">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                  </v-toolbar-items>
                </v-toolbar>

                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="formValidado">
                      <v-row style="padding-top: 10px;" justify="center">
                        <v-col cols="12" sm="6" md="6">
                          <v-text-field v-model="editedItem.nome_familia_atendimento"
                            :label="$t('crudFamiliasAtendimento.form.fields.nome')"
                            :disabled="isInterna(editedItem)"
                            :hint="isInterna(editedItem) ? $t('crudFamiliasAtendimento.form.fields.internaHint') : ''"
                            :persistent-hint="isInterna(editedItem)"
                            :rules="[nomeRules]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-select v-model="editedItem.id_equipe"
                            :items="equipes"
                            item-text="nome_equipe"
                            item-value="id_equipe"
                            :label="$t('crudFamiliasAtendimento.form.fields.equipe')"
                            clearable></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                          <v-switch v-model="editedItem.ativo" class="ma-2"
                            :label="$t('crudFamiliasAtendimento.form.fields.ativo')"
                            color="primary"></v-switch>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
        </cadastro-toolbar>
      </template>
      <template v-slot:item.nome_equipe="{ item }">
        {{ item.nome_equipe || '-' }}
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-chip small :color="item.ativo === 1 || item.ativo === true ? 'green' : 'grey'" dark>
          {{ item.ativo === 1 || item.ativo === true ? $t('crudFamiliasAtendimento.activeYes') : $t('crudFamiliasAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.interna="{ item }">
        <v-chip small :color="isInterna(item) ? 'blue-grey' : 'grey lighten-1'" dark>
          {{ isInterna(item) ? $t('crudFamiliasAtendimento.activeYes') : $t('crudFamiliasAtendimento.activeNo') }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" color="green" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon v-if="!isInterna(item)" small class="mr-2" color="red" @click="deleteItem(item)">mdi-delete</v-icon>
        <v-icon v-else small class="mr-2" color="grey"
          :title="$t('crudFamiliasAtendimento.messages.internaCannotDelete')">mdi-lock</v-icon>
      </template>
    </merus-data-table>
  </div>
</template>

<script>

import apiController from "@/utils/apiController";
import { validador } from "@/constants";
import EventBus from "../../utils/eventBus";
import MerusDataTable from '../Tables/MerusDataTable.vue';
import CadastroToolbar from '../Toolbars/CadastroToolbar.vue';

export default {
  components: {
    MerusDataTable,
    CadastroToolbar,
  },
  data: () => ({
    headers: [],
    user: null,
    token: null,
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    confirmDialog: false,
    mensagemdialog: "",
    loadingtable: true,
    search: "",
    equipes: [],
    familiasAtendimento: [],
    editedIndex: -1,
    editedItem: {
      id_familia_atendimento: null,
      nome_familia_atendimento: null,
      id_equipe: null,
      ativo: true,
      interna: 0,
    },
    deletedItem: {
      id_familia_atendimento: null,
      nome_familia_atendimento: null,
      ativo: null,
    },
    defaultItem: {
      id_familia_atendimento: null,
      nome_familia_atendimento: null,
      id_equipe: null,
      ativo: true,
      interna: 0,
    },
  }),
  computed: {
    messageDismissButton() { return this.$t('button.dismiss'); },
    messageConfirmButton() { return this.$t('button.confirm'); },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('crudFamiliasAtendimento.form.title.create')
        : this.$t('crudFamiliasAtendimento.form.title.edit');
    },
    defaultSort() {
      return [
        { value: 'nome_familia_atendimento', options: { text: this.$t('system.labels.increasing'), value: 1 } }];
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaEquipes();
    this.populaFamiliasAtendimento();
  },
  mounted() { },
  methods: {

    // Famílias internas são referenciadas pelo nome no backend: o nome é somente leitura e o registro não pode ser excluído
    isInterna(item) {
      return item && (item.interna === 1 || item.interna === true);
    },
    nomeRules() {
      if (!validador(this.editedItem.nome_familia_atendimento, 1, 100, 1, 1)) {
        return this.$t('crudFamiliasAtendimento.form.validation.nameRequired');
      }
      return true;
    },
    populaEquipes() {
      apiController.request(apiController.endpoints.getallEquipes, {
        onSuccess: (response) => {
          this.equipes = (response.data || []).filter(e => e.ativo === 1 || e.ativo === true);
        },
      });
    },
    populaFamiliasAtendimento() {
      apiController.request(apiController.endpoints.getallFamiliasatendimento, {
        onSuccess: (response) => {
          this.familiasAtendimento = response.data;
          this.loadingtable = false;
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    editItem(item) {
      this.editedIndex = this.familiasAtendimento.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.ativo = item.ativo === 1 || item.ativo === true;
      this.editedItem.id_equipe = item.id_equipe != null ? item.id_equipe : null;
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = Object.assign({}, item);
      if (this.isInterna(item)) {
        this.mensagemdialog = this.$t('crudFamiliasAtendimento.messages.internaCannotDelete');
        this.showConfirmButton = false;
        this.confirmDialog = true;
        return;
      }
      this.mensagemdialog = this.$t('crudFamiliasAtendimento.messages.confirmDelete', { nome: item.nome_familia_atendimento });
      this.showConfirmButton = true;
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteFamiliaatendimento, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        const payload = {
          id_familia_atendimento: this.editedItem.id_familia_atendimento,
          nome_familia_atendimento: this.editedItem.nome_familia_atendimento,
          id_equipe: this.editedItem.id_equipe || null,
          ativo: this.editedItem.ativo ? 1 : 0,
        };
        if (this.editedIndex === -1) {
          this.operacao = 0;
          apiController.request(apiController.endpoints.insertFamiliaatendimento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        } else {
          this.operacao = 1;
          apiController.request(apiController.endpoints.updateFamiliaatendimento, {
            data: payload,
            onSuccess: (response) => {
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      let mensagem = "";
      const tipo = status ? "error" : "success";

      if (status) {
        if (this.operacao === 0) {
          mensagem = this.$t('crudFamiliasAtendimento.messages.errorInclusion');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudFamiliasAtendimento.messages.errorUpdate');
        } else {
          mensagem = this.$t('crudFamiliasAtendimento.messages.errorDeletion');
        }
      } else {
        if (this.operacao === 0) {
          mensagem = this.$t('crudFamiliasAtendimento.messages.includedSuccess');
        } else if (this.operacao === 1) {
          mensagem = this.$t('crudFamiliasAtendimento.messages.updatedSuccess');
        } else {
          mensagem = this.$t('crudFamiliasAtendimento.messages.deletedSuccess');
        }
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      EventBus.$emit('show-alert', { mensagem, tipo });
      this.close();
      this.populaFamiliasAtendimento();
    },
  },
};
</script>
